<template>
<div class="con-speaker">
  <div class="speaker-container container">
    <div class="avatar">
      <img :src="speaker.avatar+'?imageView2/0/w/800'">
    </div>
    <div class="right">
      <h1><b>{{speakerConfig[speaker.typeId] && speakerConfig[speaker.typeId].name}}：</b>{{speaker.name}}</h1>
      <h6>
        <span class="item">{{speaker.company}}</span>
        <span class="item">{{speaker.position}}</span>
        <a v-if="lecture && lecture.pptLink" :href="lecture.pptLink" target="_blank" class="item ppt display-pc"><img src="./assets/icon-pptdownload.svg"></a>
      </h6>
      <div class="content" v-html="speaker.introduce">
      </div>
    </div>
  </div>
  <section class="con-track-present" v-if="(speaker.typeId === 4 || speaker.typeId === 6) && speaker.lectureIds && speaker.lectureIds.length">
    <div class="container">
      <div class="present" v-for="(lid, id) in speaker.lectureIds" :key="id" v-if="lectures[lid]">
          <div class="left">
            <div v-for="(sid,index) in lectures[lid].speakerIds" :key="index" class="single-speaker" v-if="speakers[sid]">
              <h4>by <router-link :to="'/speaker/' + speakers[sid].id">{{speakers[sid].name}}</router-link></h4>
              <h6>{{speakers[sid].company}}</h6><small>{{speakers[sid].position}}</small>
            </div>
          </div>
          <div class="right">
            <div class="title">
              <a @click="location(lectures[lid].is_previous, lectures[lid].id)">
                {{lectures[lid].title}}
              </a>
            </div>
            <div class="content" v-html="lectures[lid].introduce"></div>
          </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  props: [
    'speaker-config',
    'speaker',
    'lecture'
  ],
  data () {
    return {}
  },
  computed: {
    lectures () {
      return this.$store.state.lectures
    },
    speakers () {
      return this.$store.state.speakers
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    location (isPre, id) {
      if (isPre !== true) {
        this.$router.push({ path: '/presentation/' + id })
      }
    }
  },
  watch: {}
}
</script>

<style lang="sass" scoped>

.con-speaker
  background-color: #f5f7f8
  padding: 100px 0
  +mobile
    padding: 30px 0
  .speaker-container
    display: flex
    justify-content: space-between
    align-items: center
  .avatar
    width: 345px
    padding-left: 30px
    flex-shrink: 0
    +mobile
      padding-left: 0
      width: 100%
      text-align: center
  .avatar img
    width: 237px
    height: 237px
    padding: 5px
    border: 1px solid #f4f6f7
    // border: 2px solid #777777
    border-radius: 50%
    background-color: #fff
    +mobile
      width: 43vw
      height: 43vw
  .right
    flex-grow: 1
  h1
    font-size: 38px
    color: #3e3a39
    +mobile
      text-align: center
      font-size: 15px
      color: rgba(var(--primary-color), .7)
      margin-top: 10px
  h6
    margin-top: 8px
    margin-bottom: 21px
    font-size: 18px
    color: #8e9ca9
    display: flex
    align-items: center
    // .item:nth-child(n+2)
      margin-left: 12px
    .item.ppt
      margin-left: 20px
    img
      height: 2.2em
    +mobile
      justify-content: center
      font-size: 12px
      text-align: center
      color: #898989
      margin: 10px 0 20 0
  .con-track-present
    background-color: #f5f7f8
    padding: 67px 0 56px 0
    .left
      width: 304px
      margint-left: 10px
      flex-shrink: 0
      display: flex
      flex-direction: column
      justify-content: center
      .single-speaker
        margin: 15px 0
        h4
          font-size: 20px
          color: #3e3a39
          a
            font-size: 20px
            color: var(--primary-color)
        h6, small
          font-size: 16px
          color: #8e9ca9
          margin-top: 9px
          line-height: 1.4em
    .right
      flex-grow: 1
      .title
        font-size: 30px
        padding-bottom: 13px
        margin-bottom: 20px
    .present
      display: flex
      padding: 50px 42px
      border-left: 8px solid var(--primary-color)
      margin-bottom: 20px
      background-color: #fff
      color: #3e3a39
      &:hover
        box-shadow: 0 0 10px rgba(218, 227, 237, .8)
</style>
